import { Component, OnInit } from '@angular/core';
import { TermsAndConditionsType } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-sweepstake-rules',
  templateUrl: './sweepstake-rules.component.html',
  styleUrls: ['./sweepstake-rules.component.scss'],
})
export class SweepstakeRulesComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType;
  screenType = ScreenType;
  constructor() {}

  ngOnInit(): void {}
}
